<template>
  <CModal :show.sync="show" centered>
    <PTreeTagInput v-model="tags" :allowed_tags="available_tags"/>
    <template #footer>
      <CButton size="sm" @click="show = false" color="secondary" v-translate>Close</CButton>
      <CButton size="sm" @click="onAddTags" color="primary" translate-context="uploader.to_upload" v-translate>Add
        Tags
      </CButton>
    </template>
  </CModal>
</template>

<script>
import PTreeTagInput from "@/domain/core/components/PTreeTagInput.vue";

export default {
  name: "TagSelector",
  components: {PTreeTagInput},
  props: {
    available_tags: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      show: false,
      tags: []
    }
  },
  computed: {},
  emits: ['update'],
  methods: {
    open(tags) {
      this.show = true
      this.tags = tags ?? []
    },
    onAddTags() {
      this.$emit('update', this.tags)
      this.show = false
    }
  }
}
</script>

<style scoped>

</style>